import React, { useState, useEffect,useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ShareButton from './icon/shareicome';
import RepostButton from './icon/repostbutton';
import Loading from './icon/loading';

import { resolveAvatarUrl, handleAvatarError } from '../utils/profilePicUrl';
import { getMediaMimeType, isMediaImage, isMediaVideo } from '../utils/mediaDetect';
import PostMediaGrid from './shared/PostMediaGrid';
import AuthorNameLink from './shared/AuthorNameLink';
import MentionInput from './shared/MentionInput';
import CaptionAssist, { plainExcerpt } from './shared/CaptionAssist';
import { sanitizeHtml } from '../utils/sanitizeHtml';
import ReactionButton from './shared/ReactionButton';
import RepostModal from './shared/RepostModal';
import { DEFAULT_REACTION } from '../utils/reactions';
import { appendMentionedField, createLinkifiedText } from '../utils/mentions';
import { Upload, Send, Trash2, X, Reply, ChevronUp, ChevronRight, Flag, Ban, Bookmark } from 'lucide-react';
import ReportModal from './shared/ReportModal';
import { confirmAndBlock } from '../utils/moderation';
import { getAuthorDisplayName } from '../utils/displayName';
import { setPostSaved } from '../utils/saved';
import './PostDetail.css';
import './ActionMenu.css';
import { getChildReplies, MAX_REPLY_INDENT } from '../utils/nestReplies';

const PostDetail = ({ user, posts,onRefresh,onReply,fetchPosts  }) => {
const [showAllImages, setShowAllImages] = useState({}); // key by reply.id
const [replyMedia, setReplyMedia] = useState([]); // ✅ must be an array
  const { id } = useParams();
  const [visibleCount, setVisibleCount] = useState(5);
  const scrollRef = useRef(null);
    const [loading, setLoading] = useState({});
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [likes, setLikes] = useState({});
  const [userLiked, setUserLiked] = useState({});
  const [userReactions, setUserReactions] = useState({});
  const [reposts, setReposts] = useState({});
  const [userReposted, setUserReposted] = useState({});
  const [userCaptions, setUserCaptions] = useState({});
  const [showRepostModal, setShowRepostModal] = useState(false);
  const [repostSubmitting, setRepostSubmitting] = useState(false);
  const [replies, setReplies] = useState([]);
  const [replyText, setReplyText] = useState('');
  const [showReplyMenu, setShowReplyMenu] = useState({});
  const [showPostMenu, setShowPostMenu] = useState(false);
  const [reportTarget, setReportTarget] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [loadingReply, setLoadingReply] = useState(false);
  const [activeReplyBox, setActiveReplyBox] = useState(null);
  const [nestedReplyText, setNestedReplyText] = useState({});
  const [nestedReplyMedia, setNestedReplyMedia] = useState({});
  const [showNestedReplies, setShowNestedReplies] = useState({});
  const [loadingNestedReply, setLoadingNestedReply] = useState({});
const [popupPhoto, setPopupPhoto] = useState(null);
  const [showFullContent, setShowFullContent] = useState(false);
const [expandedPostId, setExpandedPostId] = useState(null);
  const closePopup = () => setPopupPhoto(null);
const toggleContent = () => setShowFullContent(prev => !prev);
const [profile, setProfile] = useState(null);
  const [expandedContent, setExpandedContent] = useState({});

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    setReplyMedia((prev) => [...prev, ...files]);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setReplyMedia((prev) => [...prev, ...files]);
  };

// Utility to truncate by word
const getShortContent = (text, wordLimit = 100) => {
  const words = text.split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;
};
const removeFile = (index) => {
    setReplyMedia((prev) => prev.filter((_, i) => i !== index));
  };
 const API_URL= process.env.REACT_APP_API_URL;

useEffect(() => {
 
}, []);

 useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    

    const fetchPost = async () => {
      try {
        const viewerParam = user?.id ? `&viewer_id=${user.id}` : '';
        const response = await fetch(`${API_URL}/get_posts.php?post_id=${id}${viewerParam}`, { signal });
        const data = await response.json();

        if (data.success && Array.isArray(data.posts)) {
          const matchedPost = data.posts.find((p) => p.id.toString() === id);
          if (matchedPost) {
            // Opening a quote-repost card → go to the original discussion
            if (
              matchedPost.post_type === 'repost' &&
              matchedPost.original_post_id
            ) {
              navigate(`/home/post/${matchedPost.original_post_id}`, { replace: true });
              return;
            }
            setPost(matchedPost);
            setIsSaved(Boolean(matchedPost.is_saved));
            setReplies(matchedPost.replies || []);
          } else {
            console.warn(`Post with id ${id} not found.`);
            navigate('/');
          }
        } else {
          console.warn('Invalid response format or no posts found.');
          navigate('/');
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Fetch error:', err.message);
          navigate('/');
        }
      }
    };

    fetchPost();

    return () => controller.abort();
  }, [id, navigate, user?.id]);

  
  useEffect(() => {
    if (!user?.id || !post?.id) return;

    const fetchLikes = async () => {
      try {
        const res = await fetch(`${API_URL}/get_likes.php?user_id=${user.id}`);
        const data = await res.json();
        if (data.success) {
          setLikes(data.total_likes || {});
          setUserLiked(data.user_liked || {});
          setUserReactions(data.user_reactions || {});
        } else {
          console.warn('Failed to load like data');
        }
      } catch (err) {
        console.error('Error fetching likes:', err.message);
      }
    };

    const fetchReposts = async () => {
      try {
        const res = await fetch(`${API_URL}/get_reposts.php?user_id=${user.id}`);
        const data = await res.json();
        if (data.success) {
          setReposts(data.total_reposts || {});
          setUserReposted(data.user_reposted || {});
          setUserCaptions(data.user_captions || {});
        }
      } catch (err) {
        console.error('Error fetching reposts:', err.message);
      }
    };

    fetchLikes();
    fetchReposts();
  }, [user?.id, post?.id]);

const handleLike = async (targetId, type = 'post', reactionType = DEFAULT_REACTION) => {
  const key = `${type}_${targetId}`;
  const liked = userLiked[key];
  const currentReaction = userReactions[key] || DEFAULT_REACTION;
  const removing = reactionType === null || (liked && reactionType === currentReaction);
  const changing = liked && !removing && reactionType !== currentReaction;
  const url = removing ? 'unlike.php' : 'like.php';

  try {
    const body = {
      user_id: user.id,
      target_id: targetId,
      target_type: type,
    };
    if (!removing) {
      body.reaction_type = reactionType || DEFAULT_REACTION;
    }

    const res = await fetch(`${API_URL}/${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(body),
    });

    const data = await res.json();

    if (data.success) {
      const nextReaction = removing
        ? null
        : data.reaction_type || reactionType || DEFAULT_REACTION;

      setLikes((prev) => ({
        ...prev,
        [key]: removing
          ? Math.max(0, (prev[key] || 1) - 1)
          : changing
            ? (prev[key] || 1)
            : (prev[key] || 0) + 1,
      }));

      setUserLiked((prev) => ({
        ...prev,
        [key]: !removing,
      }));

      setUserReactions((prev) => {
        const next = { ...prev };
        if (removing) delete next[key];
        else next[key] = nextReaction;
        return next;
      });
    } else {
      if (!liked && data.message !== 'Already liked') {
        alert(data.message || 'Like failed');
      }
    }
  } catch (err) {
    console.error('Like/unlike request failed:', err.message);
    alert('Network error: ' + err.message);
  }
};


const isImage = (url, type) => isMediaImage(url, type);
const isVideo = (url, type) => isMediaVideo(url, type);
const isAudio = (url) => /\.(mp3|wav|ogg)$/i.test(url);
const isDocument = (url) => /\.(pdf|docx?|pptx?|xlsx?)$/i.test(url);

const getMimeType = (url, type) => {
  if (isVideo(url, type) || isImage(url, type)) return getMediaMimeType(url, type);
  if (isAudio(url)) return 'audio/mpeg';
  if (isDocument(url)) return 'application/pdf';
  return 'application/octet-stream';
};




const submitReply = async () => {
  if (!replyText && replyMedia.length === 0) {
    return;
  }

  setLoadingReply(true);

  const formData = new FormData();
  appendMentionedField(formData, 'text', replyText);
  formData.append('user_id', user.id);
  formData.append('post_id', post.id);

  // Ensure replyMedia is an array before calling forEach
  (replyMedia || []).forEach((file) => {
    formData.append('media[]', file);
  });

  try {
    const res = await fetch(`${API_URL}/add_reply.php`, {
      method: 'POST',
      body: formData,
    });
    const data = await res.json();

    if (data.success && data.reply) {
      // ✅ Update the state immediately with the new reply data from the server.
      // This includes the new ID and any other server-generated data.
      setReplies((prevReplies) => [...prevReplies, data.reply]);
      // Reset input fields
      setReplyText('');
      setReplyMedia([]);

      // Optional: scroll to the newly added reply
      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      
    } else {
      alert(data.message || 'Reply submission failed.');
    }
  } catch (err) {
    console.error('Network error:', err);
    alert('Network or server error: ' + err.message);
  } finally {
    setLoadingReply(false);
  }
};

const handleNestedReplySubmit = async (parentReplyId) => {
  const text = nestedReplyText[parentReplyId]?.trim() || '';
  const files = nestedReplyMedia[parentReplyId] || [];

  if (!text && files.length === 0) return;

  setLoadingNestedReply((prev) => ({ ...prev, [parentReplyId]: true }));

  const formData = new FormData();
  formData.append('post_id', post.id);
  formData.append('user_id', user.id);
  appendMentionedField(formData, 'text', text);
  formData.append('parent_reply_id', parentReplyId);
  files.forEach((file) => formData.append('media[]', file));

  try {
    const res = await fetch(`${API_URL}/add_reply.php`, {
      method: 'POST',
      body: formData,
    });
    const data = await res.json();

    if (data.success && data.reply) {
      setReplies((prev) => [...prev, data.reply]);
      setNestedReplyText((prev) => ({ ...prev, [parentReplyId]: '' }));
      setNestedReplyMedia((prev) => ({ ...prev, [parentReplyId]: [] }));
      setActiveReplyBox(null);
      setShowNestedReplies((prev) => ({ ...prev, [parentReplyId]: true }));
    } else {
      alert(data.message || 'Reply submission failed.');
    }
  } catch (err) {
    console.error('Error posting nested reply:', err);
    alert('Network or server error: ' + err.message);
  } finally {
    setLoadingNestedReply((prev) => ({ ...prev, [parentReplyId]: false }));
  }
};
const formatTimeAgo = (dateString) => {
  const diff = Date.now() - new Date(dateString).getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return 'Just now';
};

// delete reply: 
const handleDeleteReply = async (replyId) => {
  if (window.confirm("Are you sure you want to delete this reply?")) {
    try {
      const formData = new FormData();
      formData.append('reply_id', replyId);
      formData.append('user_id', user?.id || '');

      const response = await fetch(`${API_URL}/delete_reply.php`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        // ✅ Update state by filtering out the deleted reply and everything under it
        setReplies((prevReplies) => {
          const removed = new Set([Number(replyId)]);
          let grew = true;
          while (grew) {
            grew = false;
            for (const reply of prevReplies) {
              if (
                !removed.has(Number(reply.id)) &&
                removed.has(Number(reply.parent_reply_id))
              ) {
                removed.add(Number(reply.id));
                grew = true;
              }
            }
          }
          return prevReplies.filter((reply) => !removed.has(Number(reply.id)));
        });
        alert(result.message);
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Failed to delete reply:", error);
      alert("Failed to delete reply. Please try again.");
    }
  }
};


// Renders one reply card plus its own replies, so a thread can go any depth.
const renderReplyCard = (reply, depth = 0) => {
  const isChild = depth > 0;
  const replyWords = String(reply.text || '').split(' ');
  const childReplies = getChildReplies(replies, reply.id);
  const canManageReply =
    user &&
    (Number(user.id) === Number(reply.user_id) ||
      user.role === 'admin');

  return (
    <article className={isChild ? 'pd-reply-card pd-reply-card--child' : 'pd-reply-card'}>
      <div className="pd-reply-head">
        <img
          src={resolveAvatarUrl(reply, API_URL)}
          onError={handleAvatarError}
          alt=""
          className={isChild ? "pd-reply-avatar pd-reply-avatar--sm" : "pd-reply-avatar"}
        />
        <div className="pd-reply-meta">
          <span className="pd-reply-name">
            <AuthorNameLink user={reply} />
          </span>
          <span className="pd-time">
            {formatTimeAgo(reply.created_at)}
          </span>
          {!isChild && (
            <span className="pd-chip">
              {reply.category || 'General'}
            </span>
          )}
          {!isChild && (reply.location || reply.country) && (
            <>
              <span className="pd-dot" aria-hidden="true">
                ·
              </span>
              <span className="pd-time">
                {reply.location || reply.country}
              </span>
            </>
          )}
        </div>

        {user && (
          <div className="pd-reply-menu am-wrap">
            <button
              type="button"
              className="am-trigger"
              aria-label="Reply options"
              aria-expanded={Boolean(showReplyMenu[reply.id])}
              onClick={() =>
                setShowReplyMenu((prev) => ({
                  ...prev,
                  [reply.id]: !prev[reply.id],
                }))
              }
            >
              ⋮
            </button>
            {showReplyMenu[reply.id] && (
              <div className="am-menu" role="menu">
                {canManageReply && (
                <button
                  type="button"
                  role="menuitem"
                  className="am-item am-item--danger"
                  onClick={() => {
                    handleDeleteReply(reply.id);
                    setShowReplyMenu((prev) => ({
                      ...prev,
                      [reply.id]: false,
                    }));
                  }}
                >
                  <span
                    className="am-icon am-icon--delete"
                    aria-hidden="true"
                  >
                    <Trash2 strokeWidth={2.2} />
                  </span>
                  <span className="am-label">Delete</span>
                </button>
                )}
                {Number(user.id) !== Number(reply.user_id) && (
                  <button
                    type="button"
                    role="menuitem"
                    className="am-item"
                    onClick={() => {
                      setReportTarget({ type: 'reply', id: reply.id, name: getAuthorDisplayName(reply) });
                      setShowReplyMenu((prev) => ({
                        ...prev,
                        [reply.id]: false,
                      }));
                    }}
                  >
                    <span className="am-icon am-icon--report" aria-hidden="true">
                      <Flag strokeWidth={2.2} />
                    </span>
                    <span className="am-label">Report comment</span>
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <p
        className={isChild ? "pd-reply-body pd-reply-body--child" : "pd-reply-body"}
        dangerouslySetInnerHTML={{
          __html: expandedContent[reply.id] || replyWords.length <= 50
            ? createLinkifiedText(String(reply.text || ''))
            : createLinkifiedText(
                replyWords.slice(0, 50).join(' ') + '...'
              ),
        }}
      />

      {replyWords.length > 50 && (
        <button
          type="button"
          className="pd-see-more"
          style={isChild ? undefined : { marginLeft: 50, marginBottom: 8 }}
          onClick={() =>
            setExpandedContent((prev) => ({
              ...prev,
              [reply.id]: prev[reply.id] ? null : reply.text,
            }))
          }
        >
          {expandedContent[reply.id] ? 'See less' : 'See more'}
        </button>
      )}

      {Array.isArray(reply.media) && reply.media.length > 0 && (
        <div className={isChild ? "pd-reply-media pd-reply-media--child" : "pd-reply-media"}>
          {reply.media
            .slice(
              0,
              showAllImages[reply.id] ? reply.media.length : 2
            )
            .map((item, idx) => {
              const isImg = isImage(item.url);
              const isVid = isVideo(item.url);
              if (isImg) {
                return (
                  <img
                    key={idx}
                    src={item.url}
                    alt="reply media"
                  />
                );
              }
              if (isVid) {
                return (
                  <video key={idx} controls playsInline>
                    <source
                      src={item.url}
                      type={getMimeType(item.url)}
                    />
                  </video>
                );
              }
              return null;
            })}
          {reply.media.length > 2 && (
            <button
              type="button"
              className="pd-see-more"
              onClick={() =>
                setShowAllImages((prev) => ({
                  ...prev,
                  [reply.id]: !prev[reply.id],
                }))
              }
            >
              {showAllImages[reply.id]
                ? 'Show less'
                : 'See more media'}
            </button>
          )}
        </div>
      )}

      <div className={isChild ? "pd-reply-actions pd-reply-actions--child" : "pd-reply-actions"}>
        <ReactionButton
          compact
          pill
          showLabel={false}
          iconSize={14}
          count={likes[`reply_${reply.id}`] || 0}
          userReaction={
            userReactions[`reply_${reply.id}`] || null
          }
          onReact={(reactionType) =>
            handleLike(reply.id, 'reply', reactionType)
          }
        />

        {user && (
          <button
            type="button"
            className="pd-nested-reply-btn"
            onClick={() =>
              setActiveReplyBox((prev) =>
                prev === reply.id ? null : reply.id
              )
            }
          >
            <Reply size={15} strokeWidth={2.25} />
            Reply
          </button>
        )}
      </div>

      {activeReplyBox === reply.id && user && (
        <div className="pd-nested-composer">
          <MentionInput
            userId={user?.id}
            showTools
            rows={3}
            placeholder="Write a reply... Type @ to mention a connection"
            value={nestedReplyText[reply.id] || ''}
            onChange={(value) =>
              setNestedReplyText((prev) => ({
                ...prev,
                [reply.id]: value,
              }))
            }
            style={{
              minHeight: 72,
              padding: '10px 12px',
              borderRadius: 10,
              border: '1px solid #d9e2ea',
              fontSize: 14,
              resize: 'vertical',
              outline: 'none',
              background: '#fff',
              marginBottom: 0,
            }}
          />
          <CaptionAssist
            kind="reply"
            text={nestedReplyText[reply.id] || ''}
            context={plainExcerpt(
              `Replying to: ${reply.text || ''}\nPost: ${post?.content || ''}`,
              700
            )}
            userId={user?.id || user?.user_id}
            style={{ marginTop: 8 }}
            onApply={(next) =>
              setNestedReplyText((prev) => ({
                ...prev,
                [reply.id]: next,
              }))
            }
          />

          <div
            className="pd-dropzone pd-dropzone--nested"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const files = Array.from(e.dataTransfer.files);
              setNestedReplyMedia((prev) => ({
                ...prev,
                [reply.id]: [...(prev[reply.id] || []), ...files],
              }));
            }}
            onClick={() =>
              document
                .getElementById(`nested-upload-${reply.id}`)
                ?.click()
            }
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                document
                  .getElementById(`nested-upload-${reply.id}`)
                  ?.click();
              }
            }}
          >
            <span className="pd-dropzone-icon" aria-hidden="true">
              <Upload size={16} strokeWidth={2.2} />
            </span>
            <p className="pd-dropzone-text">
              Drag and drop files here, or click to select
            </p>
            <input
              type="file"
              id={`nested-upload-${reply.id}`}
              accept="image/*,video/*"
              multiple
              style={{ display: 'none' }}
              onChange={(e) => {
                const files = Array.from(e.target.files || []);
                setNestedReplyMedia((prev) => ({
                  ...prev,
                  [reply.id]: [
                    ...(prev[reply.id] || []),
                    ...files,
                  ],
                }));
              }}
            />
          </div>

          {(nestedReplyMedia[reply.id] || []).length > 0 && (
            <div className="pd-previews">
              {(nestedReplyMedia[reply.id] || []).map(
                (file, idx) => (
                  <div key={idx} className="pd-preview">
                    {file.type.startsWith('image') ? (
                      <img
                        src={URL.createObjectURL(file)}
                        alt="preview"
                      />
                    ) : file.type.startsWith('video') ? (
                      <video
                        src={URL.createObjectURL(file)}
                        muted
                        loop
                      />
                    ) : null}
                    <button
                      type="button"
                      className="pd-preview-remove"
                      aria-label="Remove"
                      onClick={() =>
                        setNestedReplyMedia((prev) => ({
                          ...prev,
                          [reply.id]: prev[reply.id].filter(
                            (_, i) => i !== idx
                          ),
                        }))
                      }
                    >
                      ×
                    </button>
                  </div>
                )
              )}
            </div>
          )}

          <button
            type="button"
            className="pd-reply-submit"
            onClick={() => handleNestedReplySubmit(reply.id)}
            disabled={loadingNestedReply[reply.id]}
          >
            <Send size={16} strokeWidth={2.25} />
            <span>
              {loadingNestedReply[reply.id]
                ? 'Submitting…'
                : 'Reply'}
            </span>
          </button>
        </div>
      )}

      {childReplies.length > 0 && (
        <div
          className={
            depth + 1 >= MAX_REPLY_INDENT ? 'pd-nested pd-nested--flat' : 'pd-nested'
          }
        >
          <button
            type="button"
            className="pd-nested-toggle"
            onClick={() =>
              setShowNestedReplies((prev) => ({
                ...prev,
                [reply.id]: !prev[reply.id],
              }))
            }
          >
            <span className="pd-nested-toggle-icon" aria-hidden="true">
              {showNestedReplies[reply.id] ? (
                <ChevronUp size={14} strokeWidth={2.5} />
              ) : (
                <ChevronRight size={14} strokeWidth={2.5} />
              )}
            </span>
            <span>
              {showNestedReplies[reply.id]
                ? 'Hide replies'
                : `View ${childReplies.length} repl${
                    childReplies.length > 1 ? 'ies' : 'y'
                  }`}
            </span>
          </button>

          {showNestedReplies[reply.id] &&
            childReplies.map((child) => (
              <div key={child.id} className="pd-nested-item">
                {renderReplyCard(child, depth + 1)}
              </div>
            ))}
        </div>
      )}
    </article>
  );
};

const handleShare = (id) => {
  const shareUrl = `${window.location.origin}/home/public/${id}`;

  if (navigator.share) {
    navigator
      .share({
        title: 'Check out this post!',
        url: shareUrl,
      })
      .then(() => console.log('Post shared successfully'))
      .catch((err) => console.error('Error sharing', err));
  } else {
    navigator.clipboard.writeText(shareUrl);
    alert('Link copied to clipboard!');
  }
};

const openRepostModal = () => {
  if (!user?.id) {
    alert('Please log in first to repost.');
    return;
  }
  setShowRepostModal(true);
};

const submitRepost = async (caption) => {
  if (!post?.id || !user?.id) return;
  const key = String(post.id);
  const already = !!userReposted[key];
  setRepostSubmitting(true);
  try {
    const res = await fetch(`${API_URL}/repost.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id: user.id,
        post_id: post.id,
        action: 'repost',
        caption: caption || '',
      }),
    });
    const data = await res.json();
    if (data.success) {
      setReposts((prev) => ({
        ...prev,
        [key]: typeof data.repost_count === 'number'
          ? data.repost_count
          : Math.max(0, (prev[key] || 0) + (already ? 0 : 1)),
      }));
      setUserReposted((prev) => ({ ...prev, [key]: true }));
      setUserCaptions((prev) => ({ ...prev, [key]: data.caption ?? caption ?? '' }));
      setShowRepostModal(false);
      if (typeof onRefresh === 'function') onRefresh();
    } else {
      alert(data.message || 'Repost failed');
    }
  } catch (err) {
    console.error('Repost request failed:', err.message);
    alert('Network error: ' + err.message);
  } finally {
    setRepostSubmitting(false);
  }
};

const unrepostFromModal = async () => {
  if (!post?.id || !user?.id) return;
  const key = String(post.id);
  setRepostSubmitting(true);
  try {
    const res = await fetch(`${API_URL}/repost.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        user_id: user.id,
        post_id: post.id,
        action: 'unrepost',
      }),
    });
    const data = await res.json();
    if (data.success) {
      setReposts((prev) => ({
        ...prev,
        [key]: typeof data.repost_count === 'number'
          ? data.repost_count
          : Math.max(0, (prev[key] || 1) - 1),
      }));
      setUserReposted((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
      setUserCaptions((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
      setShowRepostModal(false);
      if (typeof onRefresh === 'function') onRefresh();
    } else {
      alert(data.message || 'Failed to undo repost');
    }
  } catch (err) {
    console.error('Unrepost request failed:', err.message);
    alert('Network error: ' + err.message);
  } finally {
    setRepostSubmitting(false);
  }
};


  if (!post) return <div className="pd-page" style={{ padding: 40 }}><Loading /></div>;

  const postCategory = post.category || 'General';
  const postTime = formatTimeAgo(post.created_at);
  const isQuestion = post.post_type === 'question';

  return (
    <>
      <div className="pd-page">
        <div className="pd-shell">
          <div className="pd-top">
            <button
              type="button"
              className="pd-close"
              aria-label="Close"
              onClick={() => navigate('/home')}
            >
              <X size={18} strokeWidth={2.4} />
            </button>
            {isQuestion && (
              <div
                style={{
                  display: 'inline-block',
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                  color: '#b45309',
                  background: '#fef3c7',
                  padding: '3px 8px',
                  borderRadius: 4,
                  marginBottom: 8,
                }}
              >
                Learning Q&A
              </div>
            )}
            <h1 className="pd-title">{post.title}</h1>
          </div>

          <div className="pd-author">
            <img
              src={resolveAvatarUrl(post, API_URL)}
              onError={handleAvatarError}
              alt=""
              className="pd-avatar"
            />
            <div className="pd-author-meta">
              <span className="pd-author-name">
                <AuthorNameLink user={post} />
              </span>
              <span className="pd-chip">{postCategory}</span>
              <span className="pd-dot" aria-hidden="true">·</span>
              <span className="pd-time">{postTime}</span>
            </div>

            {user && (
              <div className="pd-reply-menu am-wrap">
                <button
                  type="button"
                  className="am-trigger"
                  aria-label="Post options"
                  aria-expanded={showPostMenu}
                  onClick={() => setShowPostMenu((prev) => !prev)}
                >
                  ⋮
                </button>
                {showPostMenu && (
                  <div className="am-menu" role="menu">
                    <button
                      type="button"
                      role="menuitem"
                      className="am-item"
                      aria-pressed={isSaved}
                      onClick={async () => {
                        setShowPostMenu(false);
                        const next = !isSaved;
                        setIsSaved(next);
                        const result = await setPostSaved(user.id, post.id, next);
                        if (!result.success) {
                          setIsSaved(!next);
                          alert(result.message || 'Could not update saved posts.');
                        }
                      }}
                    >
                      <span className="am-icon am-icon--save" aria-hidden="true">
                        <Bookmark strokeWidth={2.2} fill={isSaved ? 'currentColor' : 'none'} />
                      </span>
                      <span className="am-label">{isSaved ? 'Remove from saved' : 'Save post'}</span>
                    </button>
                    {Number(user.id) !== Number(post.user_id) && (
                    <>
                    <button
                      type="button"
                      role="menuitem"
                      className="am-item"
                      onClick={() => {
                        setShowPostMenu(false);
                        setReportTarget({ type: 'post', id: post.id, name: getAuthorDisplayName(post) });
                      }}
                    >
                      <span className="am-icon am-icon--report" aria-hidden="true">
                        <Flag strokeWidth={2.2} />
                      </span>
                      <span className="am-label">Report post</span>
                    </button>
                    {!post.from_admin && (
                      <button
                        type="button"
                        role="menuitem"
                        className="am-item am-item--danger"
                        onClick={async () => {
                          setShowPostMenu(false);
                          const blocked = await confirmAndBlock(user, {
                            id: post.user_id,
                            name: getAuthorDisplayName(post),
                          });
                          if (blocked) {
                            onRefresh?.();
                            navigate('/home');
                          }
                        }}
                      >
                        <span className="am-icon am-icon--block" aria-hidden="true">
                          <Ban strokeWidth={2.2} />
                        </span>
                        <span className="am-label">Block {post.first_name || 'author'}</span>
                      </button>
                    )}
                    </>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="pd-body">
            {post.post_type === 'article' || post.post_type === 'blog' ? (
              <>
                {post.cover_image && (
                  <img
                    src={post.cover_image}
                    alt=""
                    style={{
                      width: '100%',
                      maxHeight: 360,
                      objectFit: 'cover',
                      borderRadius: 14,
                      marginBottom: 16,
                    }}
                  />
                )}
                <div
                  className="pd-text"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(String(post.content || '')),
                  }}
                />
              </>
            ) : (
              <>
                <p
                  className="pd-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      expandedContent[post.id] ||
                      String(post.content || '').split(' ').length <= 50
                        ? createLinkifiedText(String(post.content || ''))
                        : createLinkifiedText(
                            String(post.content || '')
                              .split(' ')
                              .slice(0, 50)
                              .join(' ') + '...'
                          ),
                  }}
                />
                {String(post.content || '').split(' ').length > 50 && (
                  <button
                    type="button"
                    className="pd-see-more"
                    onClick={() =>
                      setExpandedContent((prev) => ({
                        ...prev,
                        [post.id]: expandedContent[post.id] ? null : post.content,
                      }))
                    }
                  >
                    {expandedContent[post.id] ? 'See less' : 'See more'}
                  </button>
                )}
              </>
            )}
          </div>

          {Array.isArray(post.media) && post.media.length > 0 && (
            <div className="pd-media">
              <PostMediaGrid media={post.media} onImageClick={setPopupPhoto} />
            </div>
          )}

          {popupPhoto && (
            <div className="pd-lightbox" onClick={closePopup} role="presentation">
              <img
                src={popupPhoto}
                alt="Full size"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}

          <div className="pd-actions post-action-bar">
            <ReactionButton
              compact
              pill
              showLabel={false}
              iconSize={16}
              count={likes[`post_${post.id}`] || 0}
              userReaction={userReactions[`post_${post.id}`] || null}
              onReact={(reactionType) => handleLike(post.id, 'post', reactionType)}
            />

            <button
              type="button"
              className={`pd-action-btn${
                userReposted[String(post.id)] ? ' is-active' : ''
              }`}
              onClick={openRepostModal}
              aria-label={
                userReposted[String(post.id)] ? 'Edit repost' : 'Repost'
              }
              title={userReposted[String(post.id)] ? 'Edit repost' : 'Repost'}
            >
              <RepostButton
                count={reposts[String(post.id)] || 0}
                active={!!userReposted[String(post.id)]}
              />
            </button>

            <button
              type="button"
              className="pd-action-btn"
              onClick={() => handleShare(post.id)}
            >
              <ShareButton />
            </button>
          </div>

          <section className="pd-replies">
            <h3 className="pd-replies-title">
              {isQuestion ? 'Answers & discussion' : 'Replies'}
            </h3>

            <div className="pd-composer">
              <MentionInput
                userId={user?.id}
                showTools
                placeholder="Write your thoughts... Type @ to mention a connection"
                value={replyText}
                onChange={setReplyText}
                rows={4}
                style={{
                  minHeight: 96,
                  padding: '12px 14px',
                  borderRadius: 12,
                  border: '1px solid #d9e2ea',
                  fontSize: 14,
                  resize: 'vertical',
                  outline: 'none',
                  background: '#fff',
                  marginBottom: 0,
                }}
              />
              <CaptionAssist
                kind="reply"
                text={replyText}
                context={plainExcerpt(post?.content || post?.title || '', 700)}
                userId={user?.id || user?.user_id}
                style={{ marginTop: 8 }}
                onApply={setReplyText}
              />

              <p className="pd-composer-label">Add Photo or Video</p>

              <div
                className="pd-dropzone"
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                onClick={() => document.getElementById('mediaUploadInput')?.click()}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    document.getElementById('mediaUploadInput')?.click();
                  }
                }}
              >
                <span className="pd-dropzone-icon" aria-hidden="true">
                  <Upload size={18} strokeWidth={2.2} />
                </span>
                <p className="pd-dropzone-text">
                  Drag and drop files here, or click to select
                </p>
                <input
                  id="mediaUploadInput"
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
              </div>

              {replyMedia.length > 0 && (
                <div className="pd-previews">
                  {replyMedia.map((file, index) => (
                    <div key={index} className="pd-preview">
                      {file.type.startsWith('image') ? (
                        <img src={URL.createObjectURL(file)} alt="preview" />
                      ) : file.type.startsWith('video') ? (
                        <video src={URL.createObjectURL(file)} muted loop />
                      ) : null}
                      <button
                        type="button"
                        className="pd-preview-remove"
                        aria-label="Remove"
                        onClick={() => removeFile(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <button
                type="button"
                className="pd-reply-submit"
                onClick={submitReply}
                disabled={loadingReply}
              >
                <Send size={16} strokeWidth={2.25} />
                <span>
                  {loadingReply
                    ? 'Submitting…'
                    : isQuestion
                      ? 'Post answer'
                      : 'Reply'}
                </span>
              </button>
            </div>

            <div className="pd-reply-list">
              {replies.filter((r) => !r.parent_reply_id).length === 0 && (
                <p className="pd-empty">
                  {isQuestion ? 'No answers yet. Be the first to help.' : 'No replies yet.'}
                </p>
              )}

              {replies
                .filter((r) => !r.parent_reply_id)
                .slice(0, visibleCount)
                .map((reply) => (
                  <React.Fragment key={reply.id}>
                    {renderReplyCard(reply)}
                  </React.Fragment>
                ))}
            </div>

            {replies.filter((r) => !r.parent_reply_id).length > visibleCount && (
              <button
                type="button"
                className="pd-more"
                onClick={() => setVisibleCount((prev) => prev + 5)}
              >
                Show more replies
              </button>
            )}
          </section>
        </div>
      </div>

      <RepostModal
        open={showRepostModal}
        post={post}
        user={user}
        initialCaption={userCaptions[String(post.id)] || ''}
        alreadyReposted={!!userReposted[String(post.id)]}
        submitting={repostSubmitting}
        onClose={() => {
          if (!repostSubmitting) setShowRepostModal(false);
        }}
        onSubmit={submitRepost}
        onUnrepost={unrepostFromModal}
      />

      <ReportModal
        open={Boolean(reportTarget)}
        target={reportTarget}
        user={user}
        onClose={() => setReportTarget(null)}
      />
    </>
  );
}

export default PostDetail;
